import { Dialog } from '@mui/material';
import { cellFormat } from 'lib/designSystem/Table/cellFormat';
import EnhancedTab from 'lib/designSystem/TabSimulation';
import React from 'react';

import { useFactoringResell } from '../../context';
import FactoringResellMissingApprovalContainer from './components/Approval';
import Buybacks from './components/Buybacks';
import ResellMain from './components/NewResell';
import ResellPayments from './components/Payments';

const ResellDetails: React.FC = () => {
  const { resell, openNewResell, setOpenNewResell } = useFactoringResell();
  if (!resell) return null;
  const startValue = 0;

  const tabs = [
    {
      index: 0,
      label: 'Resumen',
      component: <ResellMain />,
    },
    {
      index: 1,
      label: 'Aprobación',
      disabled: true,
      component: <FactoringResellMissingApprovalContainer />,
    },
    {
      index: 2,
      label: 'Pagos',
      component: <ResellPayments />,
    },
    {
      index: 3,
      label: 'Recompras',
      component: <Buybacks />,
    },
  ];

  return (
    <Dialog
      maxWidth="lg"
      fullWidth
      open={openNewResell}
      onClose={() => setOpenNewResell(false)}
    >
      <div style={{ padding: 20, minHeight: 200 }}>
        <EnhancedTab
          title={`Venta #${resell.id}`}
          startValue={startValue}
          tabs={tabs}
          chip={cellFormat(resell.status, 'status-chip')}
        />
      </div>
    </Dialog>
  );
};

export default ResellDetails;
